export default __webpack_public_path__ + "static/media/PG5650-thumbnail-cc.6be6c358.png";